const API_BASE = process.env.REACT_APP_API_BASE || "";

/**
 * @param {{
 *   mode?: "filtered" | "all",
 *   category?: string,
 *   age?: string[],
 *   q?: string,
 *   loc?: string,
 *   next14?: boolean,
 * }} options
 */
export async function fetchLocationMap(options = {}) {
  const params = new URLSearchParams();
  if (options.mode) params.set("mode", options.mode);
  if (options.category) params.set("category", options.category);
  if (Array.isArray(options.age) && options.age.length > 0) {
    params.set("age", options.age.join(","));
  }
  if (options.q && String(options.q).trim()) params.set("q", String(options.q).trim());
  if (options.loc && String(options.loc).trim()) params.set("loc", String(options.loc).trim());
  if (options.next14) params.set("next14", "1");
  const queryString = params.toString();
  const url = queryString
    ? `${API_BASE}/api/locations/map?${queryString}`
    : `${API_BASE}/api/locations/map`;
  const res = await fetch(url);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Karten-Orte konnten nicht geladen werden.");
  }
  return res.json();
}
